module.exports = __webpack_public_path__ + "static/media/coin8.cee83fe4.webp";